// @module Eureka.MaxaTrendingProducts.TrendingProcuts
define('Eureka.MaxaTrendingProducts.Ezystor.View'
    ,	[
        'PageType.Base.View',
        'eureka_maxatrendingproducts_ezystor.tpl'
    ]
    , function (
        PageTypeBaseView,
        eureka_maxatrendingproducts_ezystor_tpl
    )
    {
        'use strict';

        // @class Eureka.MaxaTrendingProducts.TrendingProcuts.View @extends Backbone.View
        return PageTypeBaseView.PageTypeBaseView.extend({

            template: eureka_maxatrendingproducts_ezystor_tpl

            ,	initialize: function (options) {


            }

            , beforeShowContent: function beforeShowContent () {
                this.getBreadcrumbPages = function () {
                    return [{
                        text: 'Our Brands',
                        href: '/'
                    },{
                        text: 'Ezystor',
                        href: ''
                    }];
                };

                return jQuery.Deferred().resolve()


            }

            //@method getContext @return Eureka.MaxaTrendingProducts.TrendingProcuts.View.Context
            ,	getContext: function getContext()
            {
                return {
                };
            }
        });
    });
